import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import ContactForm from '@/components/profile/ContactForm';

export default function ContactPage() {
  return (
    <div className="min-h-screen p-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <Button variant="ghost" asChild>
            <Link to="/profiel">
              <ChevronLeft className="h-5 w-5 mr-1" />
              Terug naar profiel
            </Link>
          </Button>
        </div>

        <div className="bg-card rounded-lg p-6 border-2 border-green-500">
          <h3 className="text-lg font-medium mb-4">Contact</h3>
          <p className="mb-4">
            Heeft u vragen of opmerkingen? Vul het onderstaande formulier in of
            stuur ons een e-mail.
          </p>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}
